@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

$tabs-text-color: v.$palette-gray-800;
$tabs-dark-color: v.$palette-gray-900;
$tabs-divider-color: v.$palette-gray-200;
$tabs-accent-color: v.$palette-blue;

$tabs-transition: 0.1s;

.group {
  background: v.$palette-white;
  display: flex;
  gap: 30px;

  @include c.containerMedia(590px, "min") {
    gap: 40px;
    justify-content: flex-start;
  }
}

.control {
  border: none;
  outline: none;
  background-color: transparent;
  appearance: none;
  cursor: pointer;

  &::-moz-focus-inner {
    border: 0;
  }

  font-family: v.$primary-font;
  font-style: normal;
  padding: 0;
  padding-bottom: 16px;
  position: relative;
  @include t.text(10px, 12px, 600);

  @include c.containerMedia(590px, "min") {
    @include t.text(14px, 22px, 600);
  }

  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 2px;
    width: 100%;
    background-color: v.$palette-blue;
    opacity: 0;
    visibility: hidden;
    transition-property: opacity, visibility;
    transition-delay: $tabs-transition;
  }

  &.active {
    &:after {
      opacity: 1;
      visibility: visible;
    }

    .control-label {
      color: $tabs-accent-color;
    }
  }
}

.controlLabel {
  transition: color $tabs-transition;
  color: $tabs-dark-color;
  text-align: left;
  display: block;
}

.body {
  margin-top: 20px;
}

.panel {
  @include c.fade-in(0.2);
  z-index: 1; // because of keyframes animation
  width: 100%;
}
